import React, { useState } from 'react';
import styled from 'styled-components';

const CopyIcon = styled.button`
  background: none;
  border: none;
  padding: 2px 6px;
  margin-left: 6px;
  cursor: pointer;
  color: #9ca3af;
  transition: all 0.2s ease;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  opacity: 0.4;
  border-radius: 4px;

  &:hover {
    color: #3b82f6;
    background: #f0f4ff;
    opacity: 1;
  }

  ${({ copied }) =>
    copied &&
    `
    color: #10b981;
    opacity: 1;
  `}
`;

const Tooltip = styled.span`
  position: absolute;
  background: #1f2937;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  transform: translateY(-100%);
  margin-top: -8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;

  ${({ show }) =>
    show &&
    `
    opacity: 1;
  `}
`;

const CopyWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  position: relative;
`;

export const CopyButton = ({ value, label, showValue = true }) => {
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = async e => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value || '');
      setCopied(true);
      setShowTooltip(true);
      setTimeout(() => {
        setCopied(false);
        setShowTooltip(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  if (!value) return null;

  return (
    <CopyWrapper>
      {showValue && <span>{value}</span>}
      <CopyIcon
        onClick={handleCopy}
        copied={copied}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {copied ? <i className="bx bx-check" /> : <i className="bx bx-copy" />}
        <Tooltip show={showTooltip}>
          {copied ? 'Copied!' : `Copy ${label || 'value'}`}
        </Tooltip>
      </CopyIcon>
    </CopyWrapper>
  );
};
